<template>
  <div class="localP">
    <div class="header">
      <p-header></p-header>
    </div>
    <div class="container">
      <div class="aside">
        <el-menu
          background-color="#F5F6FA"
          active-text-color="#17B6A1"
          router
          unique-opened
          @select="menuActive"
          :default-active="defaultActiveIndex"
        >
          <m-aside :arrlist="routerlist" :msgnum="pendingRevie"></m-aside>
        </el-menu>
      </div>
      <div class="main">
        <div class="main_container_box">
          <keep-alive
            v-if="refresh"
            :exclude="[
              'epinfomsg',
              'eplist',
              'southcargo',
              'cargoinfo',
              'planlistParticulars',
              'infomsg',
              'addcarlistinfo',
              'newaddparticulars',
              'particulars',
              'newaddcheck2',
              'addnoticelist',
              'mapCar',
              'homemapdetail',
              'guijihuifang'
            ]"
          >
            <router-view></router-view>
          </keep-alive>
          <router-view v-if="!refresh"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pHeader from '@/components/pHeader.vue';
import mAside from '@/components/mAside.vue';
import { mapMutations } from 'vuex';
export default {
  provide() {
    return {
      reload: this.reload,
      changerefresh: this.changerefresh,
      alertDialog: this.alertDialog,
    };
  },
  data() {
    return {
      refresh: false,
      defaultActiveIndex: '',
      pendingRevie: {},
      routerlist: [
        {
          id: 101,
          name: '首页',
          path: '/home/homepage',
          icon: 'icon-shouye',
        }
      ],
    };
  },
  watch: {
    $route(nval,oval) {
      if(nval.meta.path){
        this.defaultActiveIndex = nval.meta.path;
      }else{
        this.defaultActiveIndex = nval.path;
      }
      
      window.sessionStorage.setItem('itemindex', nval.path);
    },
  },
  components: {
    pHeader,
    mAside,
  },
  created() {
    this.getpendingRevie();
    this.defaultActiveIndex =
      window.sessionStorage.getItem('itemindex') || '/home/homepage';
    this.getmenu();
  },
  mounted(){
    this.addTitleList(this.routerlist[0])
  },
  methods: {
    ...mapMutations(['remove', 'clearConditions',"addTitleList"]),
    changerefresh() {
      !this.refresh && (this.refresh = true);
    },
    menuActive() {
      this.refresh && (this.refresh = false);
      this.clearConditions(this.$route.path);
    },
    async getpendingRevie() {
      const { data } = await this.$http(
        'api1',
        '/port/homepage/pendingReviewCount',
        'get'
      );
      if (data.code != 0) return this.$message.error(data.msg);

      this.pendingRevie = data;
    },
    async getmenu() {
      const { data: data1 } = await this.$http('api1', '/sys/menu/nav', 'get');
      if (!data1 || data1.msg != 'success') return this.$router.push('/login');
      data1.menuList.forEach((item) => {
        var ch = [];
        item.list.forEach((it) => {
          ch.push({
            id: it.menuId,
            name: it.name,
            path: it.url,
          });
        });
        this.routerlist.push({
          id: item.menuId,
          name: item.name,
          icon: item.icon,
          children: ch,
        });
      });
    },
    reload() {
      this.refresh = false;
      this.$nextTick((_) => {
        this.refresh = true;
      });
    },
    alertDialog(info, callback) {
      if (!callback || !(callback instanceof Function))
        return console.log('请传入一个函数');
      this.$messageBox
        .confirm(info, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(callback)
        .catch((err) => err);
    },
  },
  beforeDestroy() {
    // this.remove();
  },
};
</script>
<style lang="scss" scoped>
.localP {
  // position: relative;
  // overflow: hidden;
  .header {
    background: #ffffff;
    min-width: 600px;
    box-sizing: border-box;
      height: 50px;
      padding: 12px 20px;
  }
  .container {
    // position: absolute;
    width: 100%;
    // height: 100%;
    height: calc(100% - 50px);
    display: flex;
    justify-content: space-between;
    // bottom: 0;
    .aside {
    // position: absolute;
    // top: 0;
    // bottom: 0;
    min-height: 526px;
    background: #f5f6fa;
    overflow: hidden;
    overflow-y: scroll;
    width: 12.5%;
  }
  .main {
    // position: absolute;
    // top: 0;
    // right: 0;
    // bottom: 0;
    padding: 0px;
    min-width: 1000px;
    min-height: 526px;
    width: 87.5%;
    // box-shadow: 1px 1px 3px #c2c2c2 inset;
    background: #f5f6fa;
    overflow: auto;
    .main_container_box {
      width: 100%;
      height: 100%;
      // background-color: #ffffff;
      box-shadow: 0px 3px 6px #c2c2c2;
      // overflow: hidden;
    }
  }
  }
 
}
@media screen and (max-width: 1920px) {
  .localP {
    .header {
      box-sizing: border-box;
      height: 50px;
      padding: 12px 20px;
    }
    .container {
      top: 50px;
    }
    .aside {
      width: 170px;
    }
    .main {
      left: 170px;
    }
  }
}
@media screen and (max-width: 1536px) {
  .localP {
    .header {
      box-sizing: border-box;
      height: 45px;
      padding: 12px 20px;
    }
    .container {
      top: 45px;
    }
    .aside {
      width: 170px;
    }
    .main {
      left: 170px;
    }
  }
}
@media screen and (max-width: 1366px) {
  .localP {
    .header {
      box-sizing: border-box;
      height: 40px;
      padding: 12px 20px;
    }
    .container {
      top: 40px;
    }
    .aside {
      width: 160px;
    }
    .main {
      left: 160px;
    }
  }
}
</style>
